import React, { useState, useEffect } from "react";
import { PiUser } from "react-icons/pi";
import { MdFavoriteBorder } from "react-icons/md";
import { RiShoppingCartLine, RiSearchLine } from "react-icons/ri";
import { IoChevronDownSharp } from "react-icons/io5";
import Logo from "/logo-white.png";
import LogoBlack from "/logo-black.png";
import { NavLink, useLocation, useNavigate, Link } from "react-router-dom";
import SearchPopup from "./SearchPopup";
import { VscMenu } from "react-icons/vsc";
import Sidenav from "./Sidenav";
import ProfileImg from "../../assets/images/user.jpg";
import { useQuery } from "@tanstack/react-query";
import apiClient from "../../services/apiClient";
import { useSelector, useDispatch } from "react-redux"; // added missing imports
import { IMAGE_PATH } from "../../utils/constants";
// import { IMAGE_PATH } from "../../config"; // uncomment if needed

const paths = {
  home: "/",
  products: "/products/product",
  account: "/profile/profile",
  search: "/search",
  wishlist: "/wishlist/wishlist",
  login: "/auth/login",
  cart: "/cart/cart",
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSidenav, setShowSidenav] = useState(false);
  const [profileImage, setProfileImage] = useState(ProfileImg);

  const cartItems = useSelector((state) => state.cart.items);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const isActive = (path) => location.pathname === path;

  
  useEffect(() => {
    if (user?.photo) {
      setProfileImage(`${IMAGE_PATH}${user.photo}`);
    }
  }, [user]);

  
  const { data: categories = [], isLoading, error } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await apiClient.get("/categories");
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000, 
    cacheTime: 30 * 60 * 1000, 
    refetchOnWindowFocus: false,
    refetchOnMount: false, 
  });

 
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleProductClick = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleDropdownClick = (category) => {
    navigate(paths.products, { state: { category } });
    setShowDropdown(false);
  };

  const toggleSidenav = () => setShowSidenav(!showSidenav);

  const handleLogout = () => {
    // your logout logic here
    setShowProfileDropdown(false);
  };

  // ✅ Close profile dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".userProfileItem")) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdownParent")) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      id="Navbar"
      className={`${scrolled ? "scrolled" : ""} ${
        location.pathname !== paths.home ? "otherPage" : ""
      }`}
    >
      <div className="container">
        <div className="navbarMain">
          <div className="ToogleMenuLogoBox">
            <div className="ToogleMenu" onClick={toggleSidenav}>
              <VscMenu className="menu" />
            </div>
            <div className="logo">
              <NavLink to={paths.home}>
                <img src={(scrolled && location.pathname === paths.home) ? Logo : LogoBlack} alt="Logo" />
              </NavLink>
            </div>
          </div>

          <div className="navLinks">
            <ul>
              <li>
                <NavLink
                  to={paths.home}
                  className={isActive(paths.home) ? "active" : ""}
                >
                  Home
                </NavLink>
              </li>

              <li className="dropdownParent">
                <button
                  className="dropdownToggle"
                  onClick={handleProductClick}
                >
                  Products{" "}
                  <IoChevronDownSharp
                    className={showDropdown ? "rotate" : ""}
                  />
                </button>

                {showDropdown && (
                  <ul className="dropdownMenu">
                    {isLoading ? (
                      <li>Loading categories...</li>
                    ) : error ? (
                      <li>Error loading categories</li>
                    ) : (
                      categories.map((cat) => (
                          <Link
                            key={cat.id}
                            to={`products/${cat.id}/${cat.category_name
                              .replace(/\s+/g, "-")}`}
                            onClick={() => setShowDropdown(false)}
                          >
                            {cat.category_name}
                          </Link>
                      ))
                    )}
                  </ul>
                )}
              </li>
            </ul>
          </div>

          <div className="navIcons">
            <ul>
              <li className="userProfileItem">
                <div
                  className="UserProfile"
                  onClick={() =>
                    setShowProfileDropdown(!showProfileDropdown)
                  }
                >
                  <img src={profileImage} alt="Profile" />
                </div>
                {showProfileDropdown && (
                  <div className="profileDropdown">
                    <NavLink
                      to={paths.account}
                      className={isActive(paths.account) ? "active" : ""}
                    >
                      Profile
                    </NavLink>
                    <button onClick={handleLogout}>Logout</button>
                  </div>
                )}
              </li>

              <li>
                <button
                  onClick={() => setShowSearch(true)}
                  className="searchBtn"
                >
                  <RiSearchLine />
                </button>
              </li>

              <li>
                <NavLink
                  to={paths.wishlist}
                  className={isActive(paths.wishlist) ? "active" : ""}
                >
                  <MdFavoriteBorder />
                </NavLink>
              </li>

              <li className="cartIcon">
                <NavLink
                  to={paths.cart}
                  className={isActive(paths.cart) ? "active" : ""}
                >
                  <RiShoppingCartLine />
                  <span className="cartCount">{cartItems?.length || 0}</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <SearchPopup isOpen={showSearch} onClose={() => setShowSearch(false)} />
      <Sidenav isOpen={showSidenav} onClose={toggleSidenav} paths={paths} />
    </div>
  );
};

export default Navbar;
